// extracted by mini-css-extract-plugin
export default {"GenericList":"GenericList_GenericList__V-IrP"};